<template>
    <v-img
        v-if="imageX"
        :src="imageX"
        :max-height="fill ? undefined : maxHeight"
        :height="fill ? '100%' : undefined"
        :aspect-ratio="fill ? undefined : 1.0"
        :contain="image"
    >
    </v-img>
</template>

<script>
import security from "@/main";
import Img from "@/modules/img/components/service/Img";

export default {
    name: "ImgImage",

    props: {
        id: {

        },
        /** The entry of the folder's images; with the media service it carries the renditions. */
        item: {
            required: false,
        },
        /** Fills the height of its container (centered, contained) instead of a square of at most maxHeight. */
        fill: {
            type   : Boolean,
            default: false
        },
        maxHeight: {
            type   : Number,
            default: 700
        },
        image: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },

    data: () => ({
        imageX: null
    }),

    mounted () {
        const url = Img.imageUrl(this.item, this.image ? "view" : "thumb");
        if (!url) {
            return;
        }
        fetch(url, {method: "GET", headers: security.jsonHeader()})
            .then(response => {
                return response.blob().then(blob => {
                    const data = new Blob([blob], {type: response.headers.get("Content-Type")});
                    this.imageX = URL.createObjectURL(data);
                })
            });
    },
}
</script>

<style scoped>

</style>